import http from "@/modules/core/network/http";
import Vue from "vue";

Object.defineProperty(Vue.prototype, "$http", { value: http });
